<template>
  <div>
    <strong>Atendente: </strong>
    <span v-if="mostrar">{{ atendente }}</span>
  </div>
</template>
<script>
export default {
  props: {
    mostrar: {
      type: Boolean,
      default: false,
    },
    atendente: {
      type: String,
      default: null,
    },
  },
}
</script>
